import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatInt, formatMinutes, formatUsd } from "@/lib/statsFormat";
import type { CallStatsProviderRow } from "@/services/callStatsService";

const KINDS: { kind: CallStatsProviderRow["kind"]; label: string }[] = [
  { kind: "tts", label: "TTS" },
  { kind: "stt", label: "STT" },
  { kind: "llm", label: "LLM" },
];

interface ProviderTableProps {
  rows: CallStatsProviderRow[];
}

const ProviderTable = ({ rows }: ProviderTableProps) => (
  <Card>
    <CardHeader>
      <CardTitle>Providers</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      {KINDS.map(({ kind, label }) => {
        const group = rows.filter((row) => row.kind === kind);
        if (group.length === 0) return null;
        return (
          <div key={kind}>
            <h3 className="mb-1 text-sm font-semibold">{label}</h3>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Provider</TableHead>
                  <TableHead>Model</TableHead>
                  <TableHead className="text-right">Calls</TableHead>
                  <TableHead className="text-right">Minutes</TableHead>
                  <TableHead className="text-right">Cost</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {group.map((row) => (
                  <TableRow key={`${row.provider}-${row.model}`}>
                    <TableCell>{row.provider}</TableCell>
                    <TableCell className="text-muted-foreground">
                      {row.model || "—"}
                    </TableCell>
                    <TableCell className="text-right">{formatInt(row.calls)}</TableCell>
                    <TableCell className="text-right">{formatMinutes(row.seconds)}</TableCell>
                    <TableCell className="text-right">{formatUsd(row.cost)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        );
      })}
    </CardContent>
  </Card>
);

export default ProviderTable;
